import React, { useState, useEffect } from "react";
import FormContainer from "../../../shared/components/FormContainer/FormContainer";
import BundleTable from "../../../shared/components/BundleTable";
import { fetchConfiguration ,getHbbAccoundDetails} from "../../../shared/service";
import { useLoading } from "../../../../../Shared/cache/context/LoadingProvider";
import ToastMsg from "../../../shared/components/ToastMsg/ToastMsg";
import { useNavigate } from "react-router-dom";
import { eventEmitter } from "../../../../../Shared/service/google-analytics.service";
import useFetch from "../../../../../Shared/cache/useFetch";
import { TRANSLATION,GET ,ORP_TRANSLATION } from "../../../../../Shared/helper/constants";
import { useLanguage } from "../../../../../Shared/cache/context/LanguageProvider";
import { HBB_MSISDN_CHECK } from "../../../../../Shared/helper/constants";
import AwOtpModal from "../../../../odu/components/AwOtpModal";
import Modal from "../../../../../Shared/Components/Modal";
import { getQueryBalance } from "../../../shared/service";
import "./BroadbandRecharge.scss"

const BroadbandRecharge = () => {
  const [formData, setFormData] = useState({ msisdn: "" });
  const [lineTypeRes, setLineType] = useState(false);
  const [msisdnLineType, setmsisdnLineType] = useState("");
  const { showLoader, hideLoader } = useLoading();
  const [toastMsg ,setToastMsg]=useState(null);
  const [accountDetails,setAccountDetails]=useState({})
  const [showBalanceChecker,setShowBalanceChecker]=useState(false)
  const [translation, setTranslation] = useState({
    recharge: "Recharge or Buy Bundles",
    buyABundle: "Buy a Bundle!",
    fetchYourBalance:'Fetch your Data Balance',
    dataBundles:'Data Bundle',
    balance:'Balance',
    expiryDate:"Expiry Date",
    myActiveBundles:"My Active Bundle",
    formLabel:"Enter Router/MiFi Number"
    })
  const navigate = useNavigate();
  const { languagePrefix,selectedLanguage } = useLanguage();
  const [ showOtpModal, setShowOtpModal ] = useState(false);
  const [errorModal,setErrorModal] = useState({show:false,message:''});
  const [showActiveBundles,setShowActiveBundles]=useState([]);
  const { data: data,refetch} = useFetch({
    url: ORP_TRANSLATION.replace('languagePrefix',languagePrefix),
    method: GET,
    key: TRANSLATION,
    initialEnabled: false,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });

  
  useEffect(() => {
    const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
    if (!cachedData) {
        refetch(true);
    }else {
      refetch(false)
    }
}, [selectedLanguage]);

  useEffect(() => {
    let widgetInfo = sessionStorage.getItem("widgetInfo");
    widgetInfo = JSON.parse(widgetInfo);
    if((widgetInfo?.type)?.toLowerCase()=="broadband"){
      setFormData({...formData,msisdn:widgetInfo?.msisdn})
    }
    fetchConfig();
    eventEmitter('ORP','Broadband Recharge Page Load','page load','Broadband Recharge Page Load',null);
  }, []);

  useEffect(() => {
      if (data?.broadbandRecharge) {
        setTranslation(data?.broadbandRecharge)
      }
    }, [data])

  const handleChange = (e) => {
    const { name } = e.target;
    setFormData({ ...formData, [name]: e.target.value });
  };

  const crossClick = () => {
    setFormData({ ...formData, msisdn: "" });
    setLineType(false);
  };
  const handleDataForm = (data) => {
    setLineType(data);
    setmsisdnLineType("");
    if(data && process.env.REACT_APP_OPCO.toLowerCase() == "ng"){
      setShowBalanceChecker(true);
    }else{
      setShowBalanceChecker(false);
    }
  };

  const handleFetchBalance = async () => {
    let request = { msisdn: formData.msisdn, "requestType": HBB_MSISDN_CHECK }
    showLoader();
    let result = await getHbbAccoundDetails({ data: request });
    hideLoader()
    if (result?.data?.statusCode !== 200) {
      setErrorModal({ show: true, message: result?.data?.message || "Something Went Wrong!" });
    } else {
      setAccountDetails(result?.data?.result)
      setShowOtpModal(true)
    }
  }

  const fetchConfig = () => {
    showLoader();
    fetchConfiguration()
      .then((res) => {
        res = res?.data;
        hideLoader();
        if (
          res &&
          (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
        ) {
          if (
            res?.result?.configData?.payStackConfig &&
            JSON.parse(res?.result?.configData?.payStackConfig).key
          ) {
            sessionStorage.setItem(
              "_p_y_m_e_n_t_k_e_",
              JSON.parse(res?.result?.configData?.payStackConfig).key,
              true
            );
          }
          if (res?.result?.configData) {
            sessionStorage.setItem(
              "_c_o_n_f_i_g",
              JSON.stringify(res?.result?.configData),
              true
            );
          }
          eventEmitter('ORP','Broadband Recharge Fetch Config Success','click','Broadband Recharge Fetch Config Success',null);
        }
        else{
          showToastMsg('Error',res?.message || "Something Went Wrong!")
          eventEmitter('ORP','Broadband_recharge_fetch_config_failed','click',res?.message,null);
      }
      })
      .catch((error) => {
        hideLoader();
        console.log(error);
        showToastMsg('Error',error?.error?.message ||error?.message|| "Something Went Wrong!")
        eventEmitter('ORP','Broadband Recharge Fetch Config Failed','click',error?.error?.statusCode?.toString(),null);
      });
  };
  const showToastMsg= (type,message)=>{
    setToastMsg({type,message});
    setTimeout(()=>setToastMsg(null),10000);
  }

  const handleBundleEvent=(bundleInfo)=>{
    if (!bundleInfo) {
      return;
    }
    onPackSelect(bundleInfo)
  }

  const onPackSelect = (event, bundleInfo) => {
    // event.persist();
    if (!bundleInfo) {
      return;
    }

    setFormData({ ...formData, amount: bundleInfo?.amount?.toString() });
    let txnData = {
      msisdn:process.env.REACT_APP_OPCO?.toLowerCase() == "ga" ? "0" + formData?.msisdn: formData?.msisdn,
      enableDualCurrency:process.env.REACT_APP_OPCO?.toLowerCase() == "drc" ? true : false,
      amount: bundleInfo?.amount,
      bundleInfo: bundleInfo,
      lineType: bundleInfo?.linetype || "PREPAID",
      productCode: bundleInfo?.productCode,
      description: "Broadband Bundle Purchase",
      currency: bundleInfo?.currency || process.env.REACT_APP_CURRENCY,
      redirectPage: "/broadband-recharge",
      rechargeType:  "Broadband Recharge",
      transactionType:
        (bundleInfo?.lineType || msisdnLineType).toLowerCase() == "prepaid"
          ? "PREPAID_BUNDLES"
          : "POSTPAID_BUNDLES",
    };
    sessionStorage.setItem("queryData", JSON.stringify(txnData), true);

    navigate("/payment/start");
  };

  const handleModalToggle =()=>{
    setShowOtpModal(false)
  }
  const hideErrorModal=()=>{
    setErrorModal({show:false,message:''});
  }
  const handleVerifiedEvent =(uniqueCode)=>{
    setShowOtpModal(false)
    fetchQueryBalance(uniqueCode)
  }

    const fetchQueryBalance = (uniqueCode) => {
          let postRequestData = {
              msisdn: process.env.REACT_APP_OPCO?.toLowerCase() == "ga" ? "0" + formData?.msisdn : formData?.msisdn,
              uniqueCode: uniqueCode && uniqueCode || null
          }
          let postRequest = {
              data: postRequestData,
          };
          showLoader();
          getQueryBalance(postRequest).then(
              (res) => {
                  let data;
                  res = res?.data;
                  hideLoader();
                  if (
                      res &&
                      (res.statusCode == 200 || res.status.toLowerCase() == "success")
                  ) {
                      let bundles=res?.result?.queryBalanceResult;
                      bundles=bundles?.filter(bundle=>bundle.serviceType=="DATA")
                      setShowActiveBundles(bundles)
                  } else {
                      showToastMsg('Error',res?.message || "Something Went Wrong!")
                  }
              }
              
          ).catch(error=>{
              hideLoader();
                  
          })
      }

  


  return (
    <>
      <div class="online-recharge">
        <div class="container">
          <h2>
            {translation?.recharge}
          </h2>
          <h4>{translation?.buyABundle}</h4>
        </div>
      </div>

      <div className="bundle-recharge-form">
        <div className="container">
          <div className="form-container">
            <FormContainer
              formInput={formData}
              handleChange={handleChange}
              sendDataToParent={handleDataForm}
              crossClick={crossClick}
              showAmountField={false}
              isBroadband={true}
              defaultLabel={translation?.formLabel}
            ></FormContainer>
          </div>
          {showBalanceChecker &&<div className="fetchBalance-click" onClick={handleFetchBalance}> <a>{translation?.fetchYourBalance} </a></div>}
        </div>
      </div>
      {errorModal?.show && <Modal isOpen={errorModal?.show} showClose={true} onClose={hideErrorModal}>
        <div className="modalError"> {errorModal?.message} </div>
        </Modal>}

      {lineTypeRes && (
        <BundleTable linetype={msisdnLineType} msisdn={formData?.msisdn}  buyBundleEvent={onPackSelect} />
      )}

      <Modal modalOverlayClass={"showActiveBundles"} showClose={true} isOpen={showActiveBundles?.length} onClose={()=>setShowActiveBundles([])}>
      
      <div className="popup-table">
      <div class="planTable-heading">
            <h4 >{translation?.myActiveBundles}</h4> 
      </div>
      <div className="planTable">
      {!!showActiveBundles.length && <>
          <div className="planTable-row head">
                <div className="planTable-row-col"> {translation?.dataBundles}</div>
                <div className="planTable-row-col">{translation?.balance}</div>
                <div className="planTable-row-col">{translation?.expiryDate}</div>
          </div>
        </>}
        {
        showActiveBundles.map((bundle,index)=>(
          <div className="planTable-row ">
            <div className="planTable-row-col">{bundle?.balanceDescription}</div>
            <div className="planTable-row-col">{bundle?.balanceType?.toLowerCase()=='unlimited'? '-':`${bundle?.balance}  ${bundle?.unitType}`}</div>
            <div className="planTable-row-col">{Intl.DateTimeFormat('en-GB', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            }).format(bundle?.expireTime)
            } </div>
          </div>
        ))
        }
        </div>

        </div>
        </Modal>
      {showOtpModal && <AwOtpModal toggleModalEvent={handleModalToggle} email={accountDetails?.otpRecipient} refId={accountDetails?.txnRefId} sendOtpVerifiedEvent={handleVerifiedEvent}/>}
      {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={()=> setToastMsg(null)}></ToastMsg>}
    </>
  );
};
export default BroadbandRecharge;
